import TestChoiceAnswer from "./TestChoiceAnswer";

export default TestChoiceAnswer;
